import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b024194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid mt--6" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Technician"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Equipment"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Type of Job"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Service Report Log"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterComponent = _resolveComponent("FilterComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FilterComponent, { onFilter: _ctx.getFilter }, null, 8, ["onFilter"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DataTable, {
              class: "table align-items-center table-flush ellipsis",
              options: _ctx.options,
              onInstance: _ctx.dtInstance,
              id: "maintenance-list"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["options", "onInstance"])
          ])
        ])
      ])
    ])
  ]))
}